export const DATE_FORMATS = {
    REQUEST_DATE_FORMAT: "YYYY-MM-DD",
    DEFAULT_DISPLAY_DATE: "DD.MM.YYYY",
    DAY_MONTH_FORMAT: "DD MMM, YYYY",
    MONTH_FORMAT: "MMMM",
    REQUEST_TIME_FORMAT: "HH:mm",
    DEFAULT_DISPLAY_TIME_FORMAT: "hh:mm A",
    DATE_TIME_FORMAT: "DD.MM.YYYY (hh:mm A)"
}

export type POSSIBLE_DATE_FORMATS = typeof POSSIBLE_DATE_FORMATS[number];
export const POSSIBLE_DATE_FORMATS = [
    "YYYY-MM-DD",
    "D-M-YYYYY",
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "D.MM.YYYY",
    "DD.MM.YYYY",
    "D.M.YYYY",
    "M/D/YYYY",
    "D/M/YYYY",
    "M/DD/YYYY",
] as const;